module.exports = __webpack_public_path__ + "img/connectivity.ffa9df4a.png";